import React from 'react'
import { Outlet } from 'react-router-dom'
import { Box } from '@mantine/core'

export default function PublicLayout() {
  return (
    <Box
      style={{
        flex: 1, // grow inside AgAppShell
        display: 'flex',
        flexDirection: 'column', // so Outlet can center properly
      }}
    >
      <Box
        style={{
          flex: 1, // push Outlet to take all space
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '1rem',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  )
}
